import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import axios from 'axios'; // assuming you'll post to backend
import './UploadChecks.css';
import api from './api/apiClient'
import { Box, IconButton,Typography,MenuItem, Select, InputLabel, FormControl} from '@mui/material';
import {ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";

const UploadChecks = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [fileName, setFileName] = useState('');
  const [checkType,setCheckType] = useState('');
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFileName(file.name);

    const reader = new FileReader();
    reader.onload = (evt) => {
      const binaryStr = evt.target.result;
      const workbook = XLSX.read(binaryStr, { type: 'binary' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      setData(jsonData);
    };
    reader.readAsBinaryString(file);
  };



const [processedData, setProcessedData] = useState([]);

/*const handleFileUpload = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = (evt) => {
    const binaryStr = evt.target.result;
    const workbook = XLSX.read(binaryStr, { type: "binary" });
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];

    // Parse sheet and format dates as required
    const rawData = XLSX.utils.sheet_to_json(worksheet, { raw: true });

    const formattedData = rawData.map((row) => {
      const newRow = { ...row };
      Object.keys(newRow).forEach((key) => {
        if (isLikelyDate(newRow[key])) {
          newRow[key] = convertExcelDate(newRow[key]);
        }
      });
      return newRow;
    });

    setProcessedData(formattedData);
  };
  reader.readAsBinaryString(file);
};

// Helper: Detect if value is likely an Excel date serial
const isLikelyDate = (value) =>
  typeof value === "number" && value > 10000 && value < 60000;

// Helper: Convert Excel date serial to "dd-MMM-yyyy"
/*const convertExcelDate = (serial) => {
  const utc_days = Math.floor(serial - 25569);
  const utc_value = utc_days * 86400;
  const date_info = new Date(utc_value * 1000);
  return format(date_info, "dd-MMM-yyyy"); // E.g., "15-Mar-2024"
};*/


  const handleClear = () => {
    setData([]);
    setFileName('');
  };

  const handleSubmit = async () => {
    try {
      const response = await api.post(`/checks/upload/${checkType}`, data);
//      const response = await api.post('/addresscheckones/upload', processedData);
      alert('Data uploaded successfully!');
    } catch (error) {
      console.error('Upload error:', error);
      alert('Failed to upload data');
    }
  };
  const handleBack = () => {
    navigate(-1); // Navigate to previous screen
  };
  const handleDownloadTemplate = async () => {
    if (!checkType) {
      alert('Please select a check type first.');
      return;
    }
  
    try {
      const response = await api.get(`/checks/template/download/${checkType}`);
      const labels = response.data; // array of strings
  
      // Create a worksheet with just headers (no data)
      const worksheet = XLSX.utils.aoa_to_sheet([labels]); // <--- use aoa_to_sheet
  
      // Create workbook and append sheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Template");
  
      // Generate Excel file and trigger download
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(blob, `${checkType}_template.xlsx`);
  
    } catch (error) {
      console.error("Error downloading Excel:", error);
    }
  };
  
  
  return (
    <div className="upload-container">
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <IconButton onClick={handleBack}>
          <ArrowBack />
        </IconButton>
        <Typography variant="h5" sx={{ ml: 1 }}>
           Upload Address Check One
        </Typography>
      </Box> 
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel id="check-type-label">Check Type</InputLabel>
            <Select
              labelId="check-type-label"
              value={checkType}
              label="Check Type"
              onChange={(e) => setCheckType(e.target.value)}
            >
                <MenuItem value="addresstype1">Address Type 1</MenuItem>
                <MenuItem value="companycheck">Company Check</MenuItem>
                <MenuItem value="employmentcheck">Empolyment Check</MenuItem>                
            </Select>
        </FormControl>
        <Typography
            variant="body2"
            sx={{ textDecoration: 'underline', cursor: 'pointer', color: 'blue',marginLeft:'10px' }}
            onClick={() => handleDownloadTemplate()}
          >
            Download Template
        </Typography>
      </Box>
      <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
      {fileName && <p><strong>File:</strong> {fileName}</p>}

      {data.length > 0 ? (
        <>
          <table className="upload-table">
            <thead>
              <tr>
                {Object.keys(data[0]).map((key) => (
                  <th key={key}>{key}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  {Object.keys(row).map((key) => (
                    <td key={key}>{row[key]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>

          <div className="upload-buttons">
            <button className="btn-submit" onClick={handleSubmit}>Submit</button>
            <button className="btn-clear" onClick={handleClear}>Clear</button>
          </div>
        </>
      ) : (
        <p>No data to display</p>
      )}
    </div>
  );
};

export default UploadChecks;
